/**
 * iOS App Store facts for the web app's "get the app" surfaces (footer badge +
 * mobile-browser popup). The listing ID is the production ascAppId in eas.json;
 * UpdateModal (native) links to the same ID.
 */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/open-studio-jazz/id6752910402';

/** localStorage flag: the popup has been shown on this browser (once, ever). */
export const GET_APP_POPUP_SHOWN_KEY = 'osj-get-app-popup-shown';

export interface BrowserEnv {
  userAgent: string;
  platform?: string;
  maxTouchPoints?: number;
}

/**
 * iPhone / iPad / iPod browsers (Safari, Chrome, Firefox on iOS all share the
 * WebKit UA). Modern iPadOS advertises itself as a Mac, so a touch-capable
 * "MacIntel" is treated as an iPad too.
 */
export function isIosBrowser(env: BrowserEnv): boolean {
  if (/iPad|iPhone|iPod/.test(env.userAgent)) return true;
  return env.platform === 'MacIntel' && (env.maxTouchPoints ?? 0) > 1;
}
